export const Filter = <T>(
    array: T[] = [],
    search: number | string = '',
  ): T[] => {
    return (array || []).filter((item) => {
      const value = JSON.stringify(item);
      return new RegExp(`${search}`, 'i').test(value);
    })
  };